import React from 'react';
import search from '../../assets/svg/ic-actions-search.svg';
import bgCard from '../../assets/svg/bg-card-home.svg';
import './cardhome.scss';

const CardHome = ({ valor, descricao, action, fontSize }) => {

    return (
        <div className="card-home-content" onClick={() => action()}>
            <div className="card-home">
                <span>{valor}</span>
                <img src={bgCard} height={58}/>
                <button><img src={search} height={17}/></button>
            </div>

            <div className="card-home-bottom" style={{fontSize:fontSize}}>
                {descricao}
            </div>
        </div>
    );
}

export default CardHome;